class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);



//icart 시작
const ICART_STARTUP_INTERVAL = 150;  // DOM 감시 간격 (백업용)
const ICART_STARTUP_MAX_ATTEMPTS = 30;
const ICART_FUNNEL_MAX_ATTEMPTS = 40;

function getIcartData() {
  const raw = localStorage.getItem('_iCartNodeCallData');
  if (!raw) return null;
  try {
    return JSON.parse(decodeURIComponent(escape(atob(raw))));
  } catch (e) {
    console.error('[iCart] _iCartNodeCallData parse error:', e);
    return null;
  }
}

function getDiscountTiers() {
  const icartData = getIcartData();
  if (!icartData) return [];

  let discountTiers =
    icartData?.data?.icart_global_settings?.common_data?.icart_progress_bar
      ?.discount_tiers;

  if (typeof discountTiers === 'string') {
    try {
      discountTiers = JSON.parse(discountTiers)?.tires_val;
    } catch (e) {
      console.error('[iCart] discount_tiers JSON parse error:', e);
      discountTiers = [];
    }
  } else {
    discountTiers = discountTiers?.tires_val || [];
  }

  return Array.isArray(discountTiers) ? discountTiers : [];
}

function updateIcartProgressBar(cartTotalOverride) {
  const discountTiers = getDiscountTiers();
  if (!discountTiers.length) return;

  const progressBarFill = document.querySelector(
    '.icart-pg-progress-container .icart-range-active-trird'
  );
  if (!progressBarFill) return;

  const cartTotal =
    typeof cartTotalOverride === 'number' && !isNaN(cartTotalOverride)
      ? cartTotalOverride
      : Number(icartGlobalVariable?.checkboxTotalPrice || 0);

  if (!cartTotal || isNaN(cartTotal)) return;

  const tierCount = discountTiers.length; 
  const stepPercent = 100 / tierCount;    

  const prices = discountTiers
    .map((t) => Number(t?.price_above || 0))
    .sort((a, b) => a - b);

  if (!prices.length) return;

  const lastPrice = prices[prices.length - 1];
  let percent = 0;

  if (cartTotal <= 0) {
    percent = 0;
  } else if (cartTotal >= lastPrice) {
    percent = 100;
  } else {
    let idx = prices.findIndex((p) => cartTotal <= p);
    if (idx === -1) idx = prices.length - 1;

    const prevPrice = idx === 0 ? 0 : prices[idx - 1];
    const nextPrice = prices[idx];

    const basePercent = idx * stepPercent;
    const range = nextPrice - prevPrice || 1;

    const localRatio = Math.min(
      Math.max((cartTotal - prevPrice) / range, 0),
      1
    );
    const localPercent = localRatio * stepPercent;

    percent = basePercent + localPercent;
  }

  progressBarFill.style.width = percent + '%';

  const markers = document.querySelectorAll('.icart-trird-range');
  discountTiers.forEach((tier, index) => {
    const priceAbove = tier?.price_above;
    if (!priceAbove) return;

    const markerEl = markers[index + 1];
    if (!markerEl) return;

    markerEl.style.setProperty(
      '--after-content',
      `"${priceAbove} ${Shopify.currency.active}"`
    );
    markerEl.style.left = stepPercent * (index + 1) + '%';
  });
}


function initIcartProgressOnce() {
  updateIcartProgressBar();
}

function observeIcartDom() {
  const observer = new MutationObserver(() => {
    const bar = document.querySelector(
      '.icart-pg-progress-container .icart-range-active-trird'
    );
    if (bar) {
      initIcartProgressOnce();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

function setupInitialProgressUpdateFallback() {
  let attempts = 0;
  const startupInterval = setInterval(() => {
    attempts += 1;
    updateIcartProgressBar();

    if (attempts >= ICART_STARTUP_MAX_ATTEMPTS) {
      clearInterval(startupInterval);
    }
  }, ICART_STARTUP_INTERVAL);
}

function scheduleIcartUpdate() {
  setTimeout(() => {
    const safeTotal = Number(icartGlobalVariable?.checkboxTotalPrice || 0);
    updateIcartProgressBar(safeTotal);
  }, 300);
}

['icartAddToCartEvent', 'icartSideCartOpenEvent', 'icartUpdateCartEvent'].forEach(
  (event) => {
    window.addEventListener(event, function () {
      scheduleIcartUpdate();
      if (typeof funneolRecommHrefRemove === 'function') {
        funneolRecommHrefRemove();
      }
    });
  }
);

document.addEventListener('DOMContentLoaded', () => {
  observeIcartDom();
  setupInitialProgressUpdateFallback();
  if (typeof funneolRecommHrefRemove === 'function') {
    funneolRecommHrefRemove();
  }
});
